import React, { useEffect, useState } from 'react'
import { Modal, Button, Input } from 'antd';
import moment from "moment";
import DatePicker from "react-datepicker";
import { IoCalendarOutline } from "react-icons/io5";
import Select from "react-select";
import httpclient from '../../../../components/httpclient';
import IsEmpty from '../../../../components/helpers/IsEmpty';
import ErrorDiv from '../../../../components/helpers/ErrorDiv';

export default function ModalSchedule({ visible, onClose, handleSubmit }) {

    const [provinceOption, setProvinceOption] = useState([]);
    const [province, setProvince] = useState(null);
    const [CityOption, setCityOption] = useState([]);
    const [city, setCity] = useState(null);
    const [districtOption, setDistrictOption] = useState([]);
    const [district, setDistrict] = useState(null);
    const [date, setDate] = useState();
    const [address, setAddress] = useState('');
    const [errors, setErrors] = useState({});

    useEffect(() => {
        getProvince();
    }, []);

    useEffect(() => {
        if (province) {
            getCity();
        }
    }, [province]);

    useEffect(() => {
        if (city) {
            getDistrict();
        }
    }, [city]);

    const convertDropdown = (data) => {
        let converted = [];
        data.forEach((e) => {
            converted.push({
                value: e.id,
                label: e.name,
            });
        });
        return converted
    }

    const getProvince = () => {
        let url = `${process.env.REACT_APP_BASE_API_URL}area/provinces`;
        httpclient
            .GET(url)
            .then((response) => {
                setProvinceOption(convertDropdown(response.data.data))
            })
            .catch((err) => {
            })
    }

    const getCity = () => {
        let url = `${process.env.REACT_APP_BASE_API_URL}area/province/${province.value}/cities`;
        httpclient
            .GET(url)
            .then((response) => {
                setCityOption(convertDropdown(response.data.data))
            })
            .catch((err) => {
            })
    }

    const getDistrict = () => {
        let url = `${process.env.REACT_APP_BASE_API_URL}area/city/${city.value}/subdistricts`;
        httpclient
            .GET(url)
            .then((response) => {
                setDistrictOption(convertDropdown(response.data.data))
            })
            .catch((err) => {
            })
    }

    const validate = () => {
        const newErrors = {};

        if (IsEmpty(date)) {
            newErrors.date = "Tanggal dan waktu belum dipilih";
        }
        if (IsEmpty(province)) {
            newErrors.province = "Provinsi belum dipilih";
        }
        if (IsEmpty(city)) {
            newErrors.city = "Kota/kabupaten belum dipilih";
        }
        if (IsEmpty(district)) {
            newErrors.district = "Kecamatan belum dipilih";
        }
        if (IsEmpty(address)) {
            newErrors.address = "Alamat belum dipilih";
        }
        return newErrors;
    };

    const onSubmit = () => {
        const newErrors = validate();

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
        } else {
            setErrors({})
            let data = {
                province: province.label,
                city: city.label,
                subdistrict: district.label,
                address: address,
                delivery_date: date,
            }
            // console.log(data)
            handleSubmit(data)
        }
    }

    return (
        <Modal
            className="modal-form"
            title="Atur Jadwal Pengiriman Barang"
            visible={visible}
            onCancel={onClose}
            footer={[
                <Button
                    onClick={onClose}
                    style={{
                        border: "0.75px solid #2C465C",
                        borderRadius: 6,
                        width: 120,
                        height: 48,
                        color: "#2C465C",
                    }}
                >
                    Kembali
                </Button>,
                <Button
                    type="submit"
                    onClick={onSubmit}
                    style={{
                        border: "0.75px solid #DCDCDC",
                        borderRadius: 6,
                        width: 120,
                        height: 48,
                        color: "#fff",
                        background: "#2C465C",
                    }}
                >
                    Lanjut
                </Button>,
            ]}
        >

            <div>
                <form>
                    <div className='text-center mb-4'>Tagihan akan dilunasi, silahkan atur jadwal pengiriman barang.</div>
                    <div className="row form-group">
                        <div className="col-4">
                            <label className="form-label">Tanggal Kirim :</label>
                        </div>
                        <div className="col-8">
                            <div className="w-100">
                                <DatePicker
                                    dateFormat="dd/MM/yyyy"
                                    selected={date}
                                    onChange={(date) => setDate(date)}
                                    className="form-control"
                                />
                                <IoCalendarOutline
                                    style={{ fontSize: 20, marginLeft: -50, zIndex: 99 }}
                                />
                            </div>
                            <ErrorDiv error={errors.date} />
                        </div>
                    </div>
                    <div className="row form-group">
                        <div className="col-4">
                            <labe>Waktu Kirim :</labe>
                        </div>
                        <div className="col-8">
                            <DatePicker
                                selected={date}
                                onChange={(date) => setDate(date)}
                                showTimeSelect
                                showTimeSelectOnly
                                timeIntervals={15}
                                timeCaption="Time"
                                dateFormat="HH:mm"
                                className="form-control"
                            />
                            <ErrorDiv error={errors.date} />
                        </div>
                    </div>
                    <div className="row form-group">
                        <div className="col-4">
                            <labe>Provinsi :</labe>
                        </div>
                        <div className="col-8">
                            <Select
                                options={provinceOption}
                                onChange={(e) => setProvince(e)}
                            />
                            <ErrorDiv error={errors.province} />
                        </div>
                    </div>
                    <div className="row form-group">
                        <div className="col-4">
                            <labe>Kota/Kabupaten :</labe>
                        </div>
                        <div className="col-8">
                            <Select
                                options={CityOption}
                                onChange={(e) => setCity(e)}
                            />
                            <ErrorDiv error={errors.city} />
                        </div>
                    </div>
                    <div className="row form-group">
                        <div className="col-4">
                            <labe>Kecamatan :</labe>
                        </div>
                        <div className="col-8">
                            <Select
                                options={districtOption}
                                onChange={(e) => setDistrict(e)}
                            />
                            <ErrorDiv error={errors.district} />
                        </div>
                    </div>
                    <div className="row form-group">
                        <div className="col-4">
                            <labe>Alamat :</labe>
                        </div>
                        <div className="col-8">
                            <Input.TextArea
                                required
                                rows="6"
                                type="text"
                                className="form-control border-DCDCDC text-input"
                                placeholder="Alamat outlet"
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                            />
                            <ErrorDiv error={errors.address} />
                        </div>
                    </div>
                </form>
            </div>

        </Modal>
    )
}
